<template>
  <!-- :class="post.can_be_blurred && (post.user[0].id !== authUser.user.id || post.user[0].role !== authUser.user.role) ? 'blur position-relative' : 'position-relative'" -->
  <div
    class="position-relative"
    :style="{
      'box-shadow': post.sponsered.length ? '0 0 15px rgb(0,0,0,0.1)' : 'none',
    }"
    @click="handleCloseAll"
  >
    <div
      v-if="post.sponsered.length"
      class="promoted-post-head"
      :style="{ background: getPrimary50Color() }"
    >
      <font-awesome-icon
        :icon="['fas', 'bullhorn']"
        class=""
        :style="{ height: '15px', width: '15px', color: getPrimaryColor() }"
      />
      <div class="promoted-text ml-1" :style="{ color: getPrimaryColor() }">
        PROMOTED
      </div>
    </div>
    <div
      :class="`shadow-card p-3 br0 ${post.sponsered.length ? 'br-b8m0' : 'br8m0'}`"
      :style="{
        background:
          post.user[0].role === 'doctor' ||
          post.user[0].role === 'physician' ||
          post.user[0].role === 'ohcp' ||
          post.user[0].role === 'hcp'
            ? ' #F8FEFF'
            : post.user[0].role === 'admin' && !post.sponsered.length
            ? '#F0FFFA'
            : post.user[0].role === 'nfp_administrator' ||
              post.user[0].role === 'hospital_administrator' ||
              post.user[0].role === 'clinic_administrator' ||
              post.user[0].role === 'business_administrator'
            ? '#FFFCF5'
            : '#FFFFFF',
        'box-shadow': post.sponsered.length
          ? 'none'
          : '0 0 15px rgb(0,0,0,0.1)',
      }"
    >
      <div class="post-head position-relative mb-2">
        <div
          :class="`title ${post.user[0].deactivated ? 'no-click' : 'cp'}`"
          @click="viewProfile"
        >
          <a @click="viewProfile" href="#">
            <!-- <a-avatar
              icon="user"
              :src="
                post.sponsered.length ? post.sponsered[0].url : post.user[0].url
              "
              alt
              :size="84"
              class="post-list-image"
            /> -->
            <a-avatar
              class="post-list-image text-capitalize"
              :style="{
                color: '#ffffff',
                'background-color': post.sponsered.length
                  ? post.sponsered[0].url
                  : post.user[0].url
                  ? post.user[0].url
                  : getAvatarColor(post.user[0].id),
              }"
              :size="70"
              :src="
                !post.user[0].deactivated
                  ? post.sponsered.length
                    ? post.sponsered[0].url
                    : post.user[0].url
                  : null
              "
              alt="avatar"
            >
              {{ post.user[0].deactivated ? "AU" : getPostUserInitials }}
            </a-avatar>
          </a>
        </div>
        <div
          :class="`my-auto ${post.user[0].deactivated ? 'no-click' : 'cp'}`"
          @click="viewProfile"
        >
          <div v-if="post.sponsered.length">
            <p class="m-0 p-0 cp">
              {{
                post.sponsered[0].name.charAt(0).toUpperCase() +
                post.sponsered[0].name.slice(1)
              }}
            </p>
          </div>
          <template v-else>
            <div
              class="d-flex align-items-center name-with-feeling pr-3 flex-wrap"
            >
              <p
                class="m-0 p-0 cp text-capitalize"
                @click="viewProfile"
                v-if="
                  post.user[0].role === 'patient' ||
                  post.user[0].role === 'caregiver'
                "
              >
                {{
                  post.user[0].deactivated
                    ? "Anonymous User"
                    : post.user[0].display_name
                }}
              </p>
              <p
                class="m-0 p-0 cp text-capitalize"
                @click="viewProfile"
                v-if="
                  post.user[0].role === 'hospital_administrator' ||
                  post.user[0].role === 'clinic_administrator' ||
                  post.user[0].role === 'nfp_administrator' ||
                  post.user[0].role === 'business_administrator'
                "
              >
                {{
                  post.user[0].deactivated
                    ? "Anonymous User"
                    : post.user[0].display_name
                }}
              </p>
              <p
                class="m-0 p-0 cp text-capitalize"
                @click="viewProfile"
                v-if="post.user[0].role === 'advocate'"
              >
                <!-- {{ post.user[0].first_name ? post.user[0].first_name + " " + post.user[0].last_name : post.user[0].display_name }} -->
                {{
                  post.user[0].deactivated
                    ? "Anonymous User"
                    : post.user[0].display_name || "A"
                }}
              </p>
              <p
                class="m-0 cp text-capitalize p-0"
                @click="viewProfile"
                v-if="post.user[0].role === 'admin'"
              >
                {{
                  post.user[0].display_name.charAt(0).toUpperCase() +
                    post.user[0].display_name.slice(1) || "DoveMedAdmin"
                }}
              </p>
              <p
                class="m-0 p-0 cp text-capitalize"
                @click="viewProfile"
                v-if="
                  post.user[0].role === 'doctor' ||
                  post.user[0].role === 'physician' ||
                  post.user[0].role === 'hcp'
                "
              >
                <!-- {{ "Dr. " + post.user[0].first_name.charAt(0).toUpperCase() + post.user[0].first_name.slice(1) }}
                {{ post.user[0].last_name }} -->
                {{
                  post.user[0].deactivated
                    ? "Anonymous User"
                    : post.user[0].display_name
                    ? post.user[0].display_name[0].toUpperCase() +
                      post.user[0].display_name.slice(1)
                    : "Dr."
                }}
              </p>
              <p
                class="m-0 p-0 sub-text ml-2 d-flex fw400"
                v-if="post.day_type"
              >
                was feeling
                {{ post.day_type.split(" ").reverse()[0].toLowerCase() }}
                <img
                  :src="getPostEmoji"
                  class="hw24 ml-1 my-auto"
                  alt="image"
                />
              </p>
              <p
                class="m-0 p-0 sub-text ml-2 d-flex fw400"
                v-else-if="post.celebration_type"
              >
                was celebrating {{ post.celebration_type }}
                <img
                  :src="require(`../../assets/emojis/confetti-24.png`)"
                  class="hw24 ml-2 my-auto"
                  alt="image"
                />
              </p>
              <div
                v-if="post.content_type === 'job'"
                class="ml-2 gray900 d-flex align-items-center sub-text"
              >
                <img
                  :src="require(`../../assets/emojis/briefcase-72.png`)"
                  class="hw18 mr-2"
                  alt="image"
                />
                Shared a job opening
              </div>
              <div
                v-if="post.content_type === 'event'"
                class="ml-2 gray900 d-flex align-items-center sub-text"
              >
                <img
                  :src="require(`../../assets/emojis/calendar-72.png`)"
                  class="hw18 mr-2"
                  alt="image"
                />
                Created an event
              </div>
              <div
                v-if="
                  post.content_type === 'press' ||
                  post.content_type === 'pressRelease'
                "
                class="ml-2 gray900 d-flex align-items-center sub-text"
              >
                <img
                  :src="require(`../../assets/emojis/newspaper-72.png`)"
                  class="hw18 mr-2"
                  alt="image"
                />
                Shared a press release
              </div>
            </div>

            <!-- ROLE TAGS -->
            <div
              class="post-physician py-1 px-2 turquoise-text turquoise-bg font12"
              v-if="post.user[0].role === 'admin'"
            >
              DoveMed Admin
            </div>
            <div
              class="post-physician py-1 px-2 font12"
              :style="{
                color: getPrimaryColor(),
                background: getPrimary50Color(),
              }"
              v-if="
                !post.user[0].deactivated && post.user[0].role === 'caregiver'
              "
            >
              <font-awesome-icon :icon="['far', 'hands-heart']" class="mr-1" />
              Caregiver
            </div>
            <div
              class=""
              v-if="
                !post.user[0].deactivated &&
                post.user[0].role === 'business_administrator'
              "
            >
              <span
                class="post-physician py-1 px-2 orange-text orange-bg font12"
              >
                <font-awesome-icon :icon="['far', 'store']" class="mr-1" />
                Business
              </span>
            </div>
            <div
              class="d-flex flex-wrap gap8"
              v-if="
                !post.user[0].deactivated &&
                post.user[0].role === 'hospital_administrator'
              "
            >
              <span
                class="post-physician py-1 px-2 orange-text orange-bg font12"
              >
                <font-awesome-icon
                  :icon="['far', 'hospital-alt']"
                  class="mr-1"
                />
                Hospital
              </span>
              <span
                class="font12 fw700 py-1 px-2 rounded"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                v-if="post.user[0].speciality"
              >
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div
              class="d-flex flex-wrap gap8"
              v-if="
                !post.user[0].deactivated &&
                post.user[0].role === 'clinic_administrator'
              "
            >
              <span
                class="post-physician py-1 px-2 orange-text orange-bg font12"
              >
                <font-awesome-icon :icon="['far', 'hospital']" class="mr-1" />
                Clinic
              </span>
              <span
                class="font12 fw700 py-1 px-2 rounded"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                v-if="post.user[0].speciality"
              >
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div
              class="p-0 d-flex flex-wrap gap8"
              v-if="
                !post.user[0].deactivated &&
                (post.user[0].role === 'doctor' ||
                  post.user[0].role === 'physician')
              "
            >
              <span
                class="post-physician py-1 px-2 orange-bg orange-text font12"
              >
                <font-awesome-icon :icon="['far', 'user-md']" class="mr-1" />
                Physician
              </span>
              <span
                class="font12 fw700 py-1 px-2 rounded"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                v-if="post.user[0].speciality"
              >
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div
              class="p-0 d-flex flex-wrap gap8"
              v-if="
                !post.user[0].deactivated &&
                (post.user[0].role === 'hcp' || post.user[0].role === 'ohcp')
              "
            >
              <span
                class="post-physician py-1 px-2 orange-bg orange-text font12"
              >
                <font-awesome-icon :icon="['far', 'user-nurse']" class="mr-1" />
                Advanced Practice Provider
              </span>
              <span
                class="font12 fw700 py-1 px-2 rounded"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                v-if="post.user[0].speciality"
              >
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div
              class="p-0 d-flex flex-wrap gap8"
              v-if="
                !post.user[0].deactivated &&
                (post.user[0].role === 'nfp' ||
                  post.user[0].role === 'nfp_administrator')
              "
            >
              <span
                class="post-physician py-1 px-2 orange-bg orange-text font12"
              >
                <font-awesome-icon
                  :icon="['far', 'hand-holding-heart']"
                  class="mr-1"
                />
                Non For Profit
              </span>
              <span
                class="font12 fw700 py-1 px-2 rounded"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                v-if="post.user[0].speciality"
              >
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div
              class="d-flex my-1 flex-wrap gap8"
              v-if="
                !post.user[0].deactivated && post.user[0].role === 'advocate'
              "
            >
              <div
                class="post-physician py-1 px-2 font12"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
              >
                <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
                Advocate
              </div>
              <div
                v-if="post.user[0].organization"
                class="bg-purple50 purple300 rounded fw700 font12 py-1 px-2"
              >
                Supporting {{ post.user[0].organization }}
              </div>
            </div>
            <!-- <i
              v-if="post.post_location && post.post_location.city"
              class="fa fa-map-marker"
              aria-hidden="true"
              :style="{ color: '#777' }"
              >&nbsp;{{ post.post_location.city }},
              {{ post.post_location.state }}</i
            > -->
            <!-- <div
              :style="{ color: '#777 !important' }"
              v-if="post.post_location && post.post_location.country"
            >
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              {{ post.post_location.country }}, {{ post.post_location.state }}.
            </div> -->
          </template>
          <p class="posted mt-1">
            {{ post.is_edited ? "Edited: " : ""
            }}{{
              formatPostTime(post.is_edited ? post.updated_at : post.post_time)
            }}
          </p>
        </div>

        <!-- MENU FOR SELF POSTS -->
        <button
          v-if="
            post.user[0].id === authUser.user.id &&
            post.user[0].role === authUser.user.role &&
            post.user_role !== 'admin'
          "
          class="threedot-menu cp"
        >
          <div
            class="dot-menu-cont"
            @click.stop="
              (e) =>
                $refs.drawerRef.isMobile ? $refs.drawerRef.show() : fetchUser(e)
            "
          >
            <font-awesome-icon
              class="gray400 h16"
              :icon="['far', 'ellipsis-v']"
            />
          </div>
          <div
            :class="`${
              displayDots
                ? 'menu-content shadow-card active'
                : 'menu-content shadow-card'
            }`"
          >
            <p
              class="card-item show-in-mobile"
              @click="
                () =>
                  $refs.sharePostModal.show(
                    { ...post },
                    getOnType(post.content_type),
                    `Share ${
                      post.content_type === 'press'
                        ? 'press release'
                        : post.content_type
                    }`
                  )
              "
            >
              <svg
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2 w30"
              >
                <path
                  d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                  fill="black"
                />
              </svg>
              Share
            </p>
            <p class="card-item" @click="(e) => handleDeletePostModal(e, post)">
              <font-awesome-icon :icon="['fal', 'trash']" class="mr-2 w30" />
              Delete
              {{
                post.content_type === "press"
                  ? "press release"
                  : post.content_type
              }}
            </p>
            <p
              class="card-item"
              @click="handleOtherModals('edit', post, post.content_type, true)"
            >
              <font-awesome-icon :icon="['fal', 'pen']" class="mr-2 w30" />
              Edit
              {{
                post.content_type === "press"
                  ? "press release"
                  : post.content_type
              }}
            </p>
          </div>
        </button>

        <!-- MENU FOR OTHERS POSTS -->
        <button v-else class="threedot-menu cp">
          <div
            class="dot-menu-cont"
            @click.stop="
              (e) =>
                $refs.drawerRef.isMobile ? $refs.drawerRef.show() : fetchUser(e)
            "
          >
            <font-awesome-icon
              class="gray400 h16"
              :icon="['far', 'ellipsis-v']"
            />
          </div>
          <div
            :class="`${
              displayDots
                ? 'menu-content shadow-card active'
                : 'menu-content shadow-card'
            }`"
          >
            <p
              class="card-item show-in-mobile"
              @click="
                () =>
                  $refs.sharePostModal.show(
                    { ...post },
                    getOnType(post.content_type),
                    `Share ${
                      post.content_type === 'press'
                        ? 'press release'
                        : post.content_type
                    }`
                  )
              "
            >
              <svg
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2 w30"
              >
                <path
                  d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                  fill="black"
                />
              </svg>
              Share
            </p>
            <p class="card-item" @click="savePost">
              <font-awesome-icon
                :icon="postSaved ? ['fas', 'bookmark'] : ['fal', 'bookmark']"
                class="mr-2 w30"
              />
              Save
            </p>
            <p
              class="card-item"
              @click="showReportModal(post)"
              v-if="!post.admin_unflagged"
            >
              <font-awesome-icon :icon="['fal', 'flag']" class="mr-2 w30" />
              Report
              {{
                post.content_type === "press"
                  ? "press release"
                  : post.content_type
              }}
            </p>
            <hr class="my-0" v-if="post.user[0].role !== 'admin'" />
            <p
              class="card-item"
              @click="muteUser"
              v-if="
                post.user[0].role !== 'admin' &&
                post.user[0].id !== authUser.user.id
              "
            >
              <font-awesome-icon
                :icon="['fal', 'comment-alt-slash']"
                class="mr-2 w30"
              />
              Mute User
            </p>
            <!-- <p
              v-if="showRemoveCircleOption"
              class="card-item"
              @click="() => $refs.removeUserModal.show(post.user[0])"
            >
              Remove from Circle
            </p> -->
          </div>
        </button>
      </div>

      <template v-if="post.content_type === 'post'">
        <div
          :class="`cp position-relative multiImgs ${
            post.post_attach_url.length === 2
              ? 'two-image-grid'
              : 'more-image-grid'
          }`"
          v-if="
            post.post_attach_url &&
            post.post_attach_url.length > 0 &&
            !showingFullScreen
          "
          @click="showFullScreen(post)"
        >
          <div
            v-for="(image, ind) in post.post_attach_url"
            :key="image.name"
            :class="`position-relative ${
              post.post_attach_url.length === 2 && 'mb-3'
            } w-100 ${getClass(ind)}`"
          >
            <template v-if="image.type">
              <img
                v-if="image.type.includes('image')"
                :src="
                  image.resized_images
                    ? image.resized_images.dov1280x720
                    : image.url
                "
                alt="image"
              />
              <video
                v-if="image.type.includes('video')"
                :src="image.url"
                controls
              />
            </template>
            <img
              v-else
              :src="
                image.resized_images
                  ? image.resized_images.dov1280x720
                  : image.url
              "
              alt="image"
            />
            <div
              v-if="image.sensitive"
              class="position-absolute flex-center-center flex-column h-100 w-100"
              :style="{ background: getSecondaryColor(), top: 0 }"
            >
              <font-awesome-icon
                :icon="['fas', 'eye-slash']"
                class="font-white hw54"
              />
            </div>
            <div
              v-if="ind === 2 && post.post_attach_url.length > 3"
              class="more"
            ></div>
            <span
              v-if="ind === 2 && post.post_attach_url.length > 3"
              class="moreText"
            >
              +{{ post.post_attach_url.length - 2 }}
            </span>
          </div>
        </div>
        <p class="mb-2" v-if="post.post_title">
          <b>{{ post.post_title }}</b>
        </p>
      </template>

      <p
        v-if="post.post_text"
        :style="{
          'white-space': 'pre-wrap',
          'margin-left': '-15px',
          overflow: 'hidden',
          height: seeMoreClicked ? 'auto' : '200px',
        }"
        class="content ql-editor post-description gray600"
        v-html="post.post_text"
        ref="postRef"
      ></p>
      <p
        class="mb-0 gray400 font14 mt-3 cp"
        @click="() => (seeMoreClicked = true)"
        v-if="!seeMoreClicked"
      >
        See More
      </p>

      <NewEventData
        v-else-if="post.content_type === 'event'"
        :displayData="{
          img: post.event_attach_url || [],
          eventName: post.event_name,
          eventType: post.event_type,
          startDate: post.start_date,
          endDate: post.end_date,
          timeZone: post.time_zones || 'UTC - 00:00',
          link: post.event_link,
          des: post.event_description,
        }"
        :noOptions="true"
        :user="post.user[0].display_name"
      />

      <NewJobData
        v-else-if="post.content_type === 'job'"
        :displayData="{
          img: post.job_attach_url || [],
          jobTitle: post.job_title,
          company: post.company_name,
          city: post.location.city,
          state: post.location.state,
          workType: post.workplace_type,
          des: post.job_description,
          link: post.job_link,
        }"
        :noOptions="true"
      />

      <NewPressReleaseData
        v-else-if="post.content_type === 'press'"
        :displayData="{
          img: post.press_attach_url || [],
          subject: post.press_subject,
          des: post.press_description,
          link: post.press_link,
        }"
        :noOptions="true"
      />

      <div
        v-if="post.parsing_link && parsedLinkDetails"
        @click="openLink"
        class="cp"
      >
        <img
          :src="parsedLinkDetails.image"
          alt="preview-img"
          :style="{ 'object-fit': 'contain', height: '360px', width: '100%' }"
          v-if="parsedLinkDetails.image"
        />
        <div
          class="p-3 bg-gray100"
          :style="{ 'border-radius': '0px 0px 8px 8px' }"
        >
          <p class="mb-0 gray900 font16 fw700">{{ parsedLinkDetails.title }}</p>
          <p class="mb-0 gray600 font16">{{ parsedLinkDetails.description }}</p>
        </div>
      </div>

      <!-- tags -->
      <div v-if="post.tags && post.tags.length" class="post__tags mt-3">
        <div
          v-for="(tag, index) in post.tags.slice(0, 3)"
          :key="index"
          class="tags rounded"
          :style="{
            color: getPrimaryColor(),
            background: getPrimary50Color(),
          }"
        >
          #{{ tag }}
        </div>
        <div v-if="post.tags.length > 3" class="popover-button">
          <a-popover placement="right">
            <template slot="content">
              <p
                v-for="(tag, index) in post.tags.slice(3)"
                :key="index"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                class="rounded p-1"
              >
                #{{ tag }}
              </p>
            </template>
            <button
              :style="{
                background: getPrimary50Color(),
                color: getPrimaryColor(),
                'font-size': '10px',
                'line-height': '20px',
              }"
              class="rounded"
            >
              +{{ post.tags.length - 3 }}
            </button>
          </a-popover>
        </div>
      </div>

      <!-- like comment share etc..... -->
      <div class="d-flex like-comment-gap mt-2">
        <!-- EMBRACE -->
        <!-- <div id="hugs" class="u-options" @click="react(post, $event)">
          <font-awesome-icon
             
            :icon="
              reactions.hugs ? ['fas', 'hands-heart'] : ['fal', 'hands-heart']
            "
            :style="{ color: reactions.hugs ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">
            Embrace ({{ post.reaction.hugs }})
          </div>
        </div> -->

        <!-- LIKES -->
        <div
          id="likes"
          class="u-options showReactions"
          :style="{ 'align-items': 'center' }"
        >
          <!-- @click="react(post, $event)" -->
          <!-- <font-awesome-icon
             
            :icon="reactions.likes ? ['fas', 'heart'] : ['fal', 'heart']"
            :style="{width:'20.2px',height:'20px' , color: reactions.likes ? getPrimaryColor() : '' }"
          /> -->
          <font-awesome-icon
            v-if="!currentClickedReaction"
            :icon="['fal', 'heart']"
            :style="{
              height: '20px',
              width: '17.5px',
              'margin-right': '1px',
            }"
          />
          <img
            v-else
            :src="
              require(`../../assets/emojis/${currentClickedReaction}-40.png`)
            "
            class="hw20"
            alt="emoji"
            :style="{ transform: 'translateY(-1.5px)' }"
          />
          <div class="posted-reactions-text ml-0 text-capitalize like-text">
            {{ currentClickedReaction || "Like" }}
          </div>

          <!-- emoji reactions on hover -->
          <div
            class="emojiReactions"
            @click="react(post, $event)"
            v-if="showReactionsHover"
          >
            <emoji-reactions :handleClick="handleReactionsClick" />
          </div>
        </div>
        <!-- COMMENTS -->
        <div
          class="u-options"
          :style="{
            display: !post.allow_comments ? 'none' : 'flex',
            cursor: 'default',
          }"
        >
          <!-- @click="comments.length === 0 && fetchComments(true, 5)" -->
          <font-awesome-icon
            :style="{ height: '20px' }"
            :icon="['fal', 'comment-alt']"
          />
          <div class="posted-reactions-text like-text show-in-mobile">
            {{ pagination.total_count || 0 }}
          </div>
          <div class="posted-reactions-text" style="text-wrap: nowrap">
            {{ pagination.total_count }}
            {{ pagination.total_count > 1 ? "Comments" : "Comment" }}
            <!-- Comment ({{ post.comments_count }}) -->
          </div>
        </div>
        <!-- BOOKMARKS -->
        <!-- <div id="favorites" :style="{'align-items':'center'}" class="u-options" @click="react(post, $event)">
          <font-awesome-icon
             
            :icon="
              reactions.favorites ? ['fas', 'bookmark'] : ['fal', 'bookmark']
            "
            :style="{width:'15px',height:'20px', color: reactions.favorites ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">Bookmark</div>
        </div> -->
        <!-- SHARE -->
        <div
          class="u-options hide-in-mobile"
          @click="
            () =>
              $refs.sharePostModal.show(
                post,
                getOnType(post.content_type),
                `Share ${
                  post.content_type === 'press'
                    ? 'press release'
                    : post.content_type
                }`
              )
          "
        >
          <!-- <font-awesome-icon
             
            :icon="['fal', 'share']"
            :style="{ transform: 'scale(1.2)' }"
          /> -->
          <!-- <img
            src="../../assets/images/share.png"
            :style="{ width: '20px', height: '15px' }"
            alt="share"
          /> -->
          <svg
            width="20"
            height="15"
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="margin-bottom: 2px"
          >
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>
          <div class="posted-reactions-text">Share</div>
        </div>

        <div
          @click="() => $refs.Reactions.show()"
          class="u-options ml-auto d-flex align-items-center flex-row-reverse m-ml-0"
        >
          <span class="ml-2">
            {{ getTotalReactions() }}
          </span>
          <img
            v-for="emoji in getTopThreeReactions()"
            :key="emoji"
            :src="require(`../../assets/emojis/${emoji}-40.png`)"
            alt="emoji"
            class="hw20"
          />
          <reactions ref="Reactions" :postProp="post" :key="posting" />
        </div>
      </div>

      <hr class="mt-3" v-if="comments.length || post.allow_comments" />
      <!-- COMMENTS -->
      <div v-if="comments.length">
        <span
          v-if="comments.length < pagination.total_count"
          @click="fetchComments(true, 5)"
          :style="{
            color: getPrimaryColor(),
            textAlign: 'left',
            display: 'block',
            cursor: 'pointer',
            'font-size': '14px',
          }"
        >
          See {{ pagination.total_count - comments.length }} previous
          {{
            pagination.total_count - comments.length === 1
              ? "comment"
              : "comments"
          }}
        </span>
        <div v-for="comment in getReversedComments" :key="comment.id">
          <!-- <div v-for="(comment, index) in comments" :key="index"> -->
          <Comment
            :commentData="comment"
            :parentUserData="post.user[0]"
            :postComment="postComment"
            :removeCommentFromDisplay="removeCommentFromDisplay"
            :setLoadingScreen="setLoadingScreen"
          />
        </div>
      </div>

      <!-- Image Upload -->
      <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">
          Loading image...
        </div>
      </div>
      <div v-if="fileList.length > 0" class="image-uploading">
        <a-upload
          v-if="fileList.length > 0"
          listType="picture-card"
          class="position-relative avatar-uploader"
          :fileList="fileList"
          @preview="handlePreview"
          @change="handleChange"
        ></a-upload>
        <a-modal
          wrap-class-name="preview-modal"
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancel"
        >
          <img style="width: 100%" :src="previewImage" alt="image" />
        </a-modal>
        <!-- <a-icon
          @click="handleChange({ file: fileList, fileList: [] })"
          :style="{
            color: 'red',
            left: '48px',
            left: '40px',
            position: 'absolute',
            'z-index': 1,
            background: '#FFF',
          }"
          type="close-circle"
          theme="filled"
          class="cp rounded-circle"
        /> -->
      </div>

      <!-- COMMENT TEXT EDITOR -->
      <!-- <div class="d-flex" v-if="post.allow_comments">
        <div v-if="showWritable" style="display: flex; justify-content: space-between; align-items: center" class="post-comment mt-2">
          <div class="title d-flex align-items-center mr-2" :style="{ 'font-size': '16px' }">
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id),
              }"
              :src="authUser.user.url"
              class="text-capitalize comment-avatar"
              :size="40"
            >
              {{ getAuthUserInitials() }}
            </a-avatar>
          </div>
          <a-input
            placeholder="Add a comment..."
            :disabled="!post.allow_comments"
            v-model="comment"
            @keyup.enter="postComment()"
            style="padding-right: 0px; color: black !important"
            class="commentText"
          />
          <div class="d-flex align-items-center position-relative cp">
            <font-awesome-icon class="position-absolute cam-inp-right" :style="{ transform: 'scale(0.6)' }" :icon="['fal', 'camera']" />
            <input class="camera-icon-inp position-absolute cam-inp-right" type="file" ref="fileInput" @change="handlePicUpload()" :style="{ top: '-20px' }" />
          </div>
          <span
            class="position-absolute"
            :style="{
              display: 'flex',
              'align-self': 'center',
              'z-index': '10',
              right: '16px',
            }"
          >
            <span class="cp" :style="{ transform: 'scale(0.75)' }" ref="BlackEmojiPicker">
              <BlackEmojiPicker :visible="emojiVisible" :handleVisible="handleEmojiVisible" :insert="insert" />
            </span>
            <div class="my-auto cp font14 fw700 hide-in-mobile" :style="{ color: getPrimaryColor(), 'margin-left': '8px' }" @click="postComment()">Comment</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              class="my-auto cp font14 show-in-mobile fw700 h18"
              :style="{ fill: getPrimaryColor(), 'margin-left': '8px' }"
              @click="postComment()"
            >
              <path
                d="M81.9 27.8C47.1 12.7 12.8 50.1 30.8 83.5l69.3 128.8c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L30.8 428.5c-18 33.4 16.3 70.8 51.1 55.7L523.8 292.7c32.1-13.9 32.1-59.5 0-73.4L81.9 27.8z"
              />
            </svg>
          </span>
        </div>
      </div> -->

      <!-- <h6 class="error500 p-1 m-1 text-center bg-gray300">Comment/Reply is WIP.</h6> -->

      <div
        class="d-flex mt-2 align-items-center"
        v-if="post.allow_comments && showWritable"
        :style="{ background: '#FFF' }"
      >
        <a-avatar
          :style="{
            'background-color': authUser.user.url
              ? ''
              : getAvatarColor(authUser.user.id),
          }"
          :src="authUser.user.url"
          class="text-capitalize comment-avatar font-white fw700"
          :size="40"
          alt="avatar"
        >
          {{ getAuthUserInitials() }}
        </a-avatar>
        <div
          class="d-flex align-items-center bg-gray50 flex-grow-1 ml-2 comment-container"
        >
          <a-textarea
            placeholder="Add a comment..."
            v-model="comment"
            @keyup="handleKeyUp"
            class="commentText comment-textarea mr-3"
            auto-size
          />
          <div class="camera position-relative cp">
            <font-awesome-icon class="hw20" :icon="['fal', 'camera']" />
            <input
              class="position-absolute camera-icon-inp hw20"
              type="file"
              accept="image/png, image/jpeg, image/gif, image/svg+xml"
              ref="fileInput"
              @change="handlePicUpload()"
            />
          </div>
          <BlackEmojiPicker
            :visible="emojiVisible"
            :handleVisible="handleEmojiVisible"
            :insert="insert"
            class="cp emoji"
          />
          <div
            class="cp font14 fw700 hide-in-mobile mr-3 text"
            :style="{ color: getPrimaryColor() }"
            @click="postComment()"
          >
            Comment
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            class="cp font14 show-in-mobile fw700 h40 icon"
            :style="{ fill: getPrimaryColor() }"
            @click="postComment()"
          >
            <path
              d="M81.9 27.8C47.1 12.7 12.8 50.1 30.8 83.5l69.3 128.8c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L30.8 428.5c-18 33.4 16.3 70.8 51.1 55.7L523.8 292.7c32.1-13.9 32.1-59.5 0-73.4L81.9 27.8z"
            />
          </svg>
        </div>
      </div>

      <!-- =================== -->
    </div>
    <ReportContentModal ref="reportContentModal" />
    <RemoveUserModal
      ref="removeUserModal"
      v-on:hideDots="displayDots = false"
    />
    <SharePostModal ref="sharePostModal" />
    <DeletePostModal ref="deletePostModal" />
    <CreateNewPostModal
      ref="EditPost"
      :getPost="fetchPosts"
      :handleOtherModals="handleOtherModals"
    />
    <DrawerModal ref="drawerRef">
      <div
        @click="$refs.drawerRef.close()"
        v-if="
          post.user[0].id === authUser.user.id &&
          post.user[0].role === authUser.user.role &&
          post.user_role !== 'admin'
        "
      >
        <p
          class="drawer-item"
          @click="
            () =>
              $refs.sharePostModal.show(
                { ...post },
                getOnType(post.content_type),
                `Share ${
                  post.content_type === 'press'
                    ? 'press release'
                    : post.content_type
                }`
              )
          "
        >
          <svg
            width="20"
            height="15"
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2 w30"
          >
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>
          Share
        </p>
        <p class="drawer-item" @click="(e) => handleDeletePostModal(e, post)">
          <font-awesome-icon :icon="['fal', 'trash']" class="mr-2 w30" />
          Delete
          {{
            post.content_type === "press" ? "press release" : post.content_type
          }}
        </p>
        <p
          class="drawer-item"
          @click="handleOtherModals('edit', post, post.content_type, true)"
        >
          <font-awesome-icon :icon="['fal', 'pen']" class="mr-2 w30" />
          Edit
          {{
            post.content_type === "press" ? "press release" : post.content_type
          }}
        </p>
      </div>
      <div @click="$refs.drawerRef.close()" v-else>
        <p
          class="drawer-item"
          @click="
            () =>
              $refs.sharePostModal.show(
                { ...post },
                getOnType(post.content_type),
                `Share ${
                  post.content_type === 'press'
                    ? 'press release'
                    : post.content_type
                }`
              )
          "
        >
          <svg
            width="20"
            height="15"
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2 w30"
          >
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            />
          </svg>
          Share
        </p>
        <p class="drawer-item" @click="savePost">
          <font-awesome-icon
            :icon="postSaved ? ['fas', 'bookmark'] : ['fal', 'bookmark']"
            class="mr-2 w30"
          />
          Save
        </p>
        <p
          class="drawer-item"
          @click="showReportModal(post)"
          v-if="!post.admin_unflagged"
        >
          <font-awesome-icon :icon="['fal', 'flag']" class="mr-2 w30" />
          Report
          {{
            post.content_type === "press" ? "press release" : post.content_type
          }}
        </p>
        <hr class="my-0" v-if="post.user[0].role !== 'admin'" />
        <p
          class="drawer-item"
          @click="muteUser"
          v-if="
            post.user[0].role !== 'admin' &&
            post.user[0].id !== authUser.user.id
          "
        >
          <font-awesome-icon
            :icon="['fal', 'comment-alt-slash']"
            class="mr-2 w30"
          />
          Mute User
        </p>
      </div>
    </DrawerModal>
    <div v-if="loadingScreen || posting" class="spinnerContainer-post">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import Comment from "./Comment.vue";
import ReportContentModal from "../Modals/ReportContent.vue";
import RemoveUserModal from "../Modals/RemoveUser";
import SharePostModal from "../Modals/SharePost";
import VEmojiPicker from "v-emoji-picker";
import EmojiPicker from "vue-emoji-picker";
import packData from "v-emoji-picker/data/emojis.json";
import s3Upload from "../../utilities/imageUploader";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import { eventBus } from "../../main";
import DeletePostModal from "../Modals/deletePostModal.vue";
import CreateNewPostModal from "../Modals/CreateNewPost.vue";
import {
  faEllipsisV,
  faHeart,
  faShare,
  faBookmark,
} from "@fortawesome/free-solid-svg-icons";
import { faBullhorn } from "@fortawesome/pro-solid-svg-icons";
import {
  faHandsHeart,
  faHospitalAlt,
  faHandHoldingHeart,
} from "@fortawesome/pro-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCamera, faPen, faTrash } from "@fortawesome/pro-light-svg-icons";
import Reactions from "../Modals/activity/Reactions.vue";
import EmojiReactions from "../commons/EmojiReactions.vue";
import BlackEmojiPicker from "./BlackEmojiPicker.vue";
import NewJobData from "./createNewPost/data/Job.vue";
import NewPressReleaseData from "./createNewPost/data/PressRelease.vue";
import NewEventData from "./createNewPost/data/Event.vue";
import DrawerModal from "../Modals/DrawerModal.vue";

library.add(
  faHeart,
  faShare,
  faBullhorn,
  faBookmark,
  faHandHoldingHeart,
  faHandsHeart,
  faCamera,
  faEllipsisV,
  faPen,
  faTrash,
  faHospitalAlt
);

const UserRepository = RepositoryFactory.get("user");
const PostRepository = RepositoryFactory.get("posts");

export default {
  name: "Post",
  components: {
    Comment,
    ReportContentModal,
    RemoveUserModal,
    VEmojiPicker,
    EmojiPicker,
    SharePostModal,
    DeletePostModal,
    Reactions,
    EmojiReactions,
    BlackEmojiPicker,
    CreateNewPostModal,
    NewJobData,
    NewPressReleaseData,
    NewEventData,
    DrawerModal,
  },
  props: {
    postData: Object,
    fetchPosts: { type: Function, default: () => {} },
    showingFullScreen: Boolean,
    showFullScreen: Function,
    handleOtherModals: Function,
    // fromProfile: Boolean,
    fromShare: Boolean,
    commentId: Number,
    fromProfileSaved: Boolean,
    // highlightDetails: Object,
  },

  computed: {
    getReversedComments() {
      return this.comments.toReversed();
    },
    getPostUserInitials() {
      let f = "",
        l = "";
      // if (this.post.sponsered.length) {
      //   f = this.post.sponsered[0].name[0]
      // } else if (this.post.user[0].role === "physician" || this.post.user[0].role === "doctor" || this.post.user[0].role === "hcp") {
      //   f = this.post.user[0].first_name ? this.post.user[0].first_name[0] : "D"
      //   l = this.post.user[0].last_name ? this.post.user[0].last_name[0] : ""
      // }
      // if (this.post.user[0].role === "advocate") {
      //   f = this.post.user[0].display_name.split(" ")[0][0] || "A"
      //   l = this.post.user[0].display_name.split(" ").slice(1).join(" ")[0] || ""
      // } else {
      //   f = this.post.user[0].display_name ? this.post.user[0].display_name[0] : "D"
      // }
      if (this.post.sponsered.length) {
        f = this.post.sponsered[0].name ? this.post.sponsered[0].name[0] : "S";
        l =
          this.post.sponsered[0].name &&
          this.post.sponsered[0].name.split(" ").slice(1).join(" ")
            ? this.post.sponsered[0].name.split(" ").slice(1).join(" ")[0]
            : "";
      } else {
        f = this.post.user[0].display_name
          ? this.post.user[0].display_name[0]
          : "D";
        l =
          this.post.user[0].display_name &&
          this.post.user[0].display_name.split(" ").slice(1).join(" ")
            ? this.post.user[0].display_name.split(" ").slice(1).join(" ")[0]
            : "";
      }
      return f.toUpperCase() + l.toUpperCase();
    },
    getPostEmoji() {
      const currentFeeling = this.typesOfFeelings.find(
        (f) => f.name === this.post.day_type.split(" ").reverse()[0]
      );
      return require(`../../assets/emojis/${
        currentFeeling ? currentFeeling.icon : "happy-40"
      }.png`);
    },
  },

  data() {
    return {
      parsedLinkDetails: {},
      seeMoreClicked: false,
      isImageUploading: false,
      loc: { lat: null, lon: null },
      showWritable: true,
      post: {},
      pagination: {
        page_num: this.currentPage,
        page_size: this.limit,
        total_count: 0,
      },
      fileList: [],
      previewImage: false,
      previewVisible: false,
      comments: [],
      comment: "",
      comment_attach: [],
      currentPage: 1,
      limit: 2,
      reactions: {
        hugs: false,
        likes: false,
        // favorites: false,
        flag: false,
        haha: false,
        emotional: false,
        angry: false,
      },
      pack: packData,
      displayDots: false,
      showRemoveCircleOption: true,
      posting: false,
      displayDeleteDots: false,
      currentClickedReaction: null,
      emojiVisible: false,
      loadingScreen: false,
      postSaved: null,
      initialCommentCall: true,
      showReactionsHover: true,
      notificationCommentCalled: false,
      typesOfFeelings: [
        { name: "good", icon: "good-32" },
        { name: "bad", icon: "bad-32" },
        { name: "okay", icon: "okay-32" },
        { name: "angry", icon: "angry-40" },
        { name: "Happy", icon: "happy-40" },
        { name: "Blessed", icon: "Blessed-24" },
        { name: "Loved", icon: "Loved-24" },
        { name: "Angry", icon: "angry-40" },
        { name: "Crazy", icon: "Crazy-24" },
        { name: "Amazing", icon: "Amazing-24" },
        { name: "Festive", icon: "Festive-24" },
        { name: "Tired", icon: "Tired-24" },
        { name: "Confident", icon: "Confident-24" },
        { name: "Hot", icon: "hot-24" },
        { name: "Cold", icon: "Cold-24" },
        { name: "Sick", icon: "Sick-24" },
        { name: "Speachless", icon: "Speachless-24" },
        { name: "Cool", icon: "Cool-24" },
        { name: "Scared", icon: "Scared-24" },
        { name: "Emotional", icon: "emotional-40" },
        { name: "Injured", icon: "Injured-24" },
        { name: "In Love", icon: "inlove-24" },
        { name: "Inlove", icon: "inlove-24" },
      ],
    };
  },

  async created() {
    this.post = this.postData;
    // console.log(this.post.content_type, "<-", this.post.post_text, "Post.vue ->", this.post)
    window.addEventListener("mouseup", (e) => {
      if (this.displayDots) {
        setTimeout(() => {
          this.displayDots = false;
        }, 100);
      }
      if (e.target.className === "emoji-picker") {
        return;
      }
      if (this.emojiVisible) {
        setTimeout(() => {
          this.emojiVisible = false;
        }, 100);
      }
    });
    const MIRROR_REACTION_TYPES = {
      1: "embrace",
      2: "like",
      8: "happy",
      9: "emotional",
      10: "angry",
    };
    const reaction_ids = [1, 2, 8, 9, 10];
    const oldReact = this.post.my_reaction.find((eachR) =>
      reaction_ids.includes(eachR.reaction_type)
    );
    this.currentClickedReaction =
      this.post.my_reaction.length && oldReact
        ? MIRROR_REACTION_TYPES[oldReact.reaction_type]
        : null;
    this.post.my_reaction.forEach((r) => {
      r.reaction_type === 4 && (this.postSaved = true);
    });

    // this.reactions.hugs = !!this.getReaction(1).length;
    // this.reactions.likes = !!this.getReaction(2).length;
    // this.reactions.favorites = !!this.getReaction(4).length;
    // this.reactions.flag = !!this.getReaction(5).length;

    eventBus.$on("flag-post", (data) => {
      if (data.id === this.post.id) {
        this.post.is_spam = true;
      }
    });
    this.post.comments_count && this.fetchComments(false, 1);
    // this.loc = await this.getLocation()
  },

  async mounted() {
    if (this.post.post_text) {
      if (
        this.post.post_text.length <= 200 ||
        this.$el.querySelector(".ql-editor").scrollHeight <= 200
      ) {
        this.seeMoreClicked = true;
      }
    } else {
      this.seeMoreClicked = true;
    }

    if (this.post.parsing_link) {
      const res = await PostRepository.parseLink({
        url: this.post.parsing_link,
      });
      this.parsedLinkDetails = res.data;
    }
  },

  methods: {
    openLink() {
      if (this.parsedLinkDetails && this.parsedLinkDetails.original_url) {
        window.open(this.parsedLinkDetails.original_url);
      }
    },
    handleKeyUp(e) {
      if (e.shiftKey) {
        return;
      } else if (e.key === "Enter") {
        e.preventDefault();
        this.postComment();
      }
    },
    getOnType(type) {
      const ON_TYPE = {
        post: 1,
        comment: 2,
        comments: 2,
        q: 3,
        poll: 5,
        job: 12,
        event: 13,
        press: 14,
        pressrelease: 14,
      };
      return ON_TYPE[type] || 1;
    },
    pauseVideo() {
      console.log("video ->", this.$el.querySelector("video"));
      this.$el.querySelector("video") &&
        this.$el.querySelector("video").pause();
    },
    getClass(i) {
      switch (i) {
        case 0:
          return "first";
        case 1:
          return "second";
        case 2:
          return "third";
        default:
          return "";
      }
    },
    setLoadingScreen(s) {
      this.loadingScreen = s;
    },
    removeCommentFromDisplay(cid, reply = false) {
      if (reply) {
        this.currentPage = 1;
        this.fetchComments(false, 1);
      } else {
        this.comments = this.comments.filter((c) => c.id !== cid);
        this.pagination.total_count -= 1;
      }
    },
    closeEmoji(e) {
      this.emojiVisible = false;
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible;
    },
    insert(emoji) {
      this.comment += emoji;
    },
    handleReactionsClick(emoji) {
      if (this.currentClickedReaction !== emoji) {
        this.currentClickedReaction = emoji;
      } else {
        this.currentClickedReaction = null;
      }
      setTimeout(() => {
        this.showReactionsHover = false;
      }, 50);
      setTimeout(() => {
        this.showReactionsHover = true;
      }, 100);
    },
    getTopThreeReactions() {
      // console.log(this.post.reaction);
      // const sortedReactions = Object.keys(this.post.reaction).sort(
      //   (a, b) => this.post.reaction[a] - this.post.reaction[b]
      // );
      // console.log(sortedReactions.slice(0, 3));
      return ["happy", "embrace", "like"];
    },
    getTotalReactions() {
      let value = 0;
      const reacts = ["angry", "sad", "happy", "likes", "hugs"];
      reacts.forEach((key) => (value = value + this.post.reaction[key]));
      return value || 0;
    },
    handleCloseAll(value = true) {
      this.displayDots = false;
      this.displayDeleteDots = false;
    },
    handleDisplayDeleteDots(e) {
      e.preventDefault();
      this.displayDeleteDots = !this.displayDeleteDots;
    },
    handleDeletePostModal(e, post) {
      e.preventDefault();
      this.displayDeleteDots = false;
      this.$refs.deletePostModal.show(post);
    },
    active() {
      return "active";
    },
    showReportModal(post) {
      this.$refs.reportContentModal.show(
        { ...post },
        this.getOnType(this.post.content_type)
      );
      this.displayDots = false;
    },

    fetchUser(e) {
      e.preventDefault();
      if (this.displayDots) {
        this.displayDots = false;
      } else {
        // this.loadingScreen = true;
        setTimeout(() => {
          // this.loadingScreen = false;
          this.displayDots = true;
        }, 50);
        // const user = this.post.user[0];
        // if (user.role === "admin") {
        //   setTimeout(() => {
        //     this.displayDots = !this.displayDots;
        //     this.showRemoveCircleOption = false;
        //     this.loadingScreen = false;
        //   }, 100);
        // } else {
        //   UserRepository.getOtherUserProfile(user, this.currentCircle.id).then(
        //     (res) => {
        //       const onCircle = res.data.data.on_circle;
        //       this.loadingScreen = false;
        //       if (!onCircle) {
        //         this.displayDots = !this.displayDots;
        //         this.showRemoveCircleOption = false;
        //       } else {
        //         this.displayDots = !this.displayDots;
        //       }
        //     }
        //   );
        // }
      }
    },

    /**
     * Get the location of the user using Geolocation
     */
    // getLocation() {
    //   return new Promise(function (resolve, reject) {
    //     navigator.geolocation.getCurrentPosition(pos => {
    //       const lat = pos.coords.latitude
    //       const lon = pos.coords.longitude
    //       resolve({ lat, lon })
    //     })
    //   })
    // },

    /**
     * Fetch comments
     *
     * @param {Object} post
     */
    fetchComments(append = false, commentsLimit = 1) {
      if (!this.initialCommentCall) {
        this.loadingScreen = true;
      }
      if (!append) {
        this.comments = [];
      }
      this.showWritable = true;
      if (this.post.content_type === "post") {
        PostRepository.fetchPostComments(
          this.post.id,
          this.currentPage,
          commentsLimit,
          !this.notificationCommentCalled ? this.commentId : null
        )
          .then((res) => {
            if (append) {
              if (this.currentPage === 1) {
                this.comments.push(...res.data.data.data.slice(1));
              } else {
                this.comments.push(...res.data.data.data);
              }
            } else {
              if (res.data.data) {
                this.comments = res.data.data.data || [];
                this.pagination = res.data.data.paginator || {};
              }
            }
            if (this.commentId && !this.notificationCommentCalled) {
              this.notificationCommentCalled = true;
            } else {
              if (this.initialCommentCall) {
                this.initialCommentCall = false;
              } else {
                this.currentPage += 1;
              }
            }
            this.loadingScreen = false;
          })
          .catch((err) => {
            this.loadingScreen = false;
          });
      } else {
        PostRepository.getOtherComments(
          this.currentCircle.id,
          this.currentPage,
          commentsLimit,
          this.post.id,
          this.post.content_type,
          !this.notificationCommentCalled ? this.commentId : null
        )
          .then((res) => {
            if (this.commentId && !this.notificationCommentCalled) {
              this.notificationCommentCalled = true;
            }
            if (append) {
              if (this.currentPage === 1) {
                this.comments.push(...res.data.data.data.slice(1));
              } else {
                this.comments.push(...res.data.data.data);
              }
            } else {
              if (res.data.data) {
                this.comments = res.data.data.data || [];
                this.pagination = res.data.data.paginator || {};
              }
            }
            if (this.initialCommentCall) {
              this.initialCommentCall = false;
            } else {
              this.currentPage += 1;
            }
            this.loadingScreen = false;
          })
          .catch((err) => {
            this.loadingScreen = false;
          });
      }
    },

    // Comment on a post
    postFunction() {
      if (this.posting) {
        return;
      }
      const ON_TYPE = {
        post: 1,
        comment: 2,
        comments: 2,
        q: 3,
        poll: 5,
        job: 10,
        event: 11,
        press: 12,
        pressrelease: 12,
      };
      this.posting = true;
      const payload = {
        // post_parent_id: this.post.id,
        comment_text: this.comment,
        user: this.authUser.user.id,
        comment_attach: this.comment_attach.length ? this.comment_attach : null,
        commented_on_type: ON_TYPE[this.post.content_type.toLowerCase()],
        // commented_on_type: 1,
        commented_on_id: this.post.id,
        latlong:
          this.loc.lat && this.loc.lon
            ? { lat: this.loc.lat, lon: this.loc.lon }
            : null,
      };
      switch (this.post.content_type.toLowerCase()) {
        case "job":
          payload.job_parent_id = this.post.id;
          break;
        case "event":
          payload.event_parent_id = this.post.id;
          break;
        case "press":
        case "pressrelease":
          payload.press_parent_id = this.post.id;
          break;
        default:
          payload.post_parent_id = this.post.id;
      }
      PostRepository.postComment(payload, this.currentCircle.id)
        .then((res) => {
          this.posting = false;
          this.comment = "";
          this.initialCommentCall = true;
          this.currentPage = 1;
          this.post.comments_count += 1;
          // this.$store.commit("Posts/addCommentCount", this.post.id)
          this.comment_attach = [];
          this.$refs.fileInput.value = "";
          this.fileList = [];
          this.emojiVisible = false;
          this.previewImage = false;
          this.previewVisible = false;
          this.comments = [];
          this.fetchComments();
        })
        .catch((err) => {
          this.posting = false;
        });
    },
    postComment() {
      if (this.comment.trim().length) {
        this.postFunction();
      }
      if (this.comment_attach.length > 0 && this.comment.trim().length === 0) {
        this.postFunction();
      }
    },

    /**
     * Remove User form Circle
     */
    removeUserFromCircle() {
      UserRepository.removeFromCircle(this.post.user[0], this.currentCircle.id)
        .then((res) => {
          this.displayDots = false;
          eventBus.$emit("on-circle");
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Cannot remove user from circle",
          });
        });
    },

    /**
     * Handle image Upload
     */
    async handlePicUpload() {
      const file = this.$refs.fileInput.files[0];
      this.isImageUploading = true;
      try {
        if (file.size / (1024 * 1024) > 5) {
          this.$notification.error({
            message: "Error",
            description: "File size exceeds 5MB limit",
          });
          // const input = this.$refs.file
          // input.type = "text"
          // input.type = "file"
        } else if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image.",
          });
        } else {
          const urlPayload = { file_name: [file.name] };
          const urlData = await UserRepository.getPresignedUrl(urlPayload);
          const fileName = urlData.data.data.filename[0];
          await s3Upload(urlData.data.data.url[0], file);
          this.comment_attach.push({ name: fileName, sensitive: false });
          const fileListData = {
            uid: this.comment_attach.length,
            name: file.name,
            status: "done",
            url: urlData.data.data.preview_url,
          };
          this.loading = false;
          this.fileList.push(fileListData);
        }
      } catch (err) {}
      this.isImageUploading = false;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    async handleChange(data) {
      this.fileList.length === 1
        ? (this.fileList = [])
        : this.fileList.splice(data.file.uid - 1, 1);
      this.comment_attach.splice(data.file.uid - 1, 1);
    },
    getPostImage() {
      if (this.post.sponsered) {
        return `${this.post.sponsered[0].url}`;
      } else {
        return `${this.post.user[0].url}`;
      }
    },

    /**
     * Get reaction of a given type
     *
     * @param {Integer} type
     */
    getReaction(type) {
      let status = [];
      status = this.post.my_reaction.filter((reaction) => {
        return (
          reaction.reaction_type === type &&
          reaction.user === this.authUser.user.id
        );
      });
      return status;
    },

    /**
     * Reaction to any post/comment. Based on the reaction, send required payload.
     *
     * @param {Object} post
     * @param {Object} event
     */
    react(entity, event, comment = false) {
      if (this.posting) {
        return;
      }
      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
       */
      // let path = event.path || (event.composedPath && event.composedPath());
      // console.log("path ==", path);

      const REACTION_TYPES = {
        HUGS: 1,
        LIKE: 2,
        USEFUL: 3,
        FAVORITE: 4,
        FLAGED: 5,
        HAHA: 8,
        EMOTIONAL: 9,
        ANGRY: 10,
      };

      const REACTION_ON = {
        POST: 1,
        COMMENT: 2,
        QUESTION: 3,
        ARTICLE: 4,
        poll: 5,
      };

      // const type = event.target.id ? event.target.id : path[1]["id"];
      const type = this.currentClickedReaction;

      // switch (type) {
      //   case "embrace":
      //   case "hug":
      //   case "hugs":
      //     this.reactions.hugs
      //       ? this.deleteReaction(REACTION_TYPES.HUGS, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.HUGS,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "likes":
      //   case "like":
      //     this.reactions.likes
      //       ? this.deleteReaction(REACTION_TYPES.LIKE, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.LIKE,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "haha":
      //   case "happy":
      //     this.reactions.haha
      //       ? this.deleteReaction(REACTION_TYPES.HAHA, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.HAHA,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "angry":
      //   case "mad":
      //     this.reactions.angry
      //       ? this.deleteReaction(REACTION_TYPES.ANGRY, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.ANGRY,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   case "sad":
      //   case "emotional":
      //     this.reactions.emotional
      //       ? this.deleteReaction(REACTION_TYPES.EMOTIONAL, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.EMOTIONAL,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   // case "favorites":
      //   //   this.reactions.favorites
      //   //     ? this.deleteReaction(REACTION_TYPES.FAVORITE, type)
      //   //     : this.saveReaction(
      //   //         entity.id,
      //   //         REACTION_TYPES.FAVORITE,
      //   //         comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //   //       );
      //   //   break;

      //   case "flag":
      //     this.reactions.flag
      //       ? this.deleteReaction(REACTION_TYPES.FLAGED, type)
      //       : this.saveReaction(
      //           entity.id,
      //           REACTION_TYPES.FLAGED,
      //           comment ? REACTION_ON.COMMENT : REACTION_ON.POST
      //         );
      //     break;

      //   default:
      //     break;
      // }
      switch (type) {
        case "embrace":
        case "hug":
        case "hugs":
          this.saveReaction(
            entity.id,
            REACTION_TYPES.HUGS,
            comment ? REACTION_ON.COMMENT : REACTION_ON.POST
          );
          break;

        case "likes":
        case "like":
          this.saveReaction(
            entity.id,
            REACTION_TYPES.LIKE,
            comment ? REACTION_ON.COMMENT : REACTION_ON.POST
          );
          break;

        case "haha":
        case "happy":
          this.saveReaction(
            entity.id,
            REACTION_TYPES.HAHA,
            comment ? REACTION_ON.COMMENT : REACTION_ON.POST
          );
          break;

        case "angry":
        case "mad":
          this.saveReaction(
            entity.id,
            REACTION_TYPES.ANGRY,
            comment ? REACTION_ON.COMMENT : REACTION_ON.POST
          );
          break;

        case "sad":
        case "emotional":
          this.saveReaction(
            entity.id,
            REACTION_TYPES.EMOTIONAL,
            comment ? REACTION_ON.COMMENT : REACTION_ON.POST
          );
          break;

        default:
          this.posting = true;
          const headers = {
            Authorization: `Bearer ${this.authUser.user.token}`,
          };
          this.$http
            .get(
              `${process.env.BASE_API_URL}/reactions/?reacted_on_id=${this.post.id}&circle_id=${this.currentCircle.id}&user_id=${this.authUser.user.id}`,
              { headers }
            )
            .then((res) => {
              this.deleteCurrentReaction(
                res.data.data[0].id,
                this.post.id,
                res.data.data[0].reaction_type,
                null,
                res.data.data[0].reaction_type
              );
            })
            .catch((err) => {
              this.posting = false;
              this.$notification.error({
                message: "Error",
                description: "Reaction could not be fetched",
              });
            });
          break;
      }
    },

    /**
     * Delete reaction to post
     *
     * @param {Integer} reactionId
     */
    deleteReaction(reactionId, type) {
      this.posting = true;
      const reactions = this.getReaction(reactionId);
      let ids = "";
      ids = reactions.map((reaction) => {
        return reaction.id;
      });
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      };
      this.reactions[type] = false;
      this.$http
        .delete(
          `${process.env.BASE_API_URL}/reactions/?ids=${ids.toString()}`,
          { headers }
        )
        .then((res) => {
          this.reactions[type] = false;
          this.posting = false;
          const deletePayload = { reactions, type };
          this.$store.commit("Posts/deletePostReactions", deletePayload);
        })
        .catch((err) => {
          this.posting = false;
        });
    },

    deleteCurrentReaction(
      idToDelete,
      postId,
      reactionType,
      reactionOnType,
      oldReaction
    ) {
      console.log("== DELETE CURRENT REACTION ==");
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
        8: "happy",
        9: "sad",
        10: "angry",
      };
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      };
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${idToDelete}`, {
          headers,
        })
        .then((res) => {
          this.reactions[MIRROR_REACTION_TYPES[oldReaction]] = false;
          this.post.reaction[MIRROR_REACTION_TYPES[oldReaction]] -= 1;
          this.post.my_reaction.length = 0;
          if (
            MIRROR_REACTION_TYPES[oldReaction] !==
            MIRROR_REACTION_TYPES[reactionType]
          ) {
            this.saveNewReaction(postId, reactionType, reactionOnType);
          } else {
            eval(
              `this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users =
                this.post.${MIRROR_REACTION_TYPES[oldReaction]}_reacted_users
                  .filter(user => {
                    return user.id !== this.authUser.user.id;
                  })`
            );
            this.posting = false;
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Reaction could not be deleted",
          });
        });
    },

    /**
     * Save reaction to post
     *
     * @param {Integer} postId
     * @param {Integer} reactionType
     * @param {Integer} reactionOnType
     */
    saveReaction(postId, reactionType, reactionOnType) {
      // console.log("== SAVE REACTION ==")
      this.posting = true;
      const headers = { Authorization: `Bearer ${this.authUser.user.token}` };
      // console.log("POST SAVED? ->", this.postSaved)
      if (
        this.postSaved
          ? this.post.my_reaction.length > 1
          : this.post.my_reaction.length
      ) {
        // console.log("== SAVE REACTION == IF ==")
        this.$http
          .get(
            `${process.env.BASE_API_URL}/reactions/?reacted_on_id=${this.post.id}&circle_id=${this.currentCircle.id}&user_id=${this.authUser.user.id}`,
            {
              headers,
            }
          )
          .then((res) => {
            this.deleteCurrentReaction(
              res.data.data[0].id,
              postId,
              reactionType,
              reactionOnType,
              res.data.data[0].reaction_type
            );
          })
          .catch((err) => {
            this.$notification.error({
              message: "Error",
              description: "Reaction could not be fetched",
            });
          });
      } else {
        // console.log("== SAVE REACTION == ELSE ==")
        this.saveNewReaction(postId, reactionType, reactionOnType);
      }
    },

    saveNewReaction(postId, reactionType, reactionOnType) {
      console.log("== SAVE NEW REACTION ==");
      const R_ON_TYPE = {
        POST: 1,
        JOB: 12,
        EVENT: 13,
        PRESS: 14,
        PRESSRELEASE: 14,
      };
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
        8: "happy",
        9: "sad",
        10: "angry",
      };
      const payload = {
        reacted_on_type: R_ON_TYPE[this.post.content_type.toUpperCase()],
        reacted_on_id: this.post.id,
        user: this.authUser.user.id,
        reaction_type: reactionType,
      };
      this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true;
      this.posting = true;

      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then((res) => {
          const headers = {
            Authorization: `Bearer ${this.authUser.user.token}`,
          };
          if (this.fromProfileSaved) {
            PostRepository.getAllTypeById(
              this.getDovemedPostApiIdName(this.post.content_type),
              this.post.id,
              this.currentCircle.id
            )
              .then((res) => {
                console.log("res.data.data.data[0]:", res.data.data.data[0]);
                this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1;
                switch (this.post.content_type) {
                  case "post":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].angry_reacted_users;
                    this.post.my_reaction = res.data.data.data[0].my_reaction;
                    break;
                  case "job":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].user_job.hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].user_job.happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].user_job.sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].user_job.likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].user_job.angry_reacted_users;
                    this.post.my_reaction =
                      res.data.data.data[0].user_job.my_reaction;
                    break;
                  case "event":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].user_event.hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].user_event.happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].user_event.sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].user_event.likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].user_event.angry_reacted_users;
                    this.post.my_reaction =
                      res.data.data.data[0].user_event.my_reaction;
                    break;
                  case "press":
                  case "pressRelease":
                  case "pressrelease":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].user_press.hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].user_press.happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].user_press.sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].user_press.likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].user_press.angry_reacted_users;
                    this.post.my_reaction =
                      res.data.data.data[0].user_press.my_reaction;
                    break;
                }
                this.posting = false;
              })
              .catch((e) => {
                this.$notification.error({
                  message: "Error - R1",
                  description: "Reacted users cannot be fetched",
                });
                this.posting = false;
              });

            // switch (this.post.content_type) {
            //   case "post":
            //     this.$http
            //       .get(
            //         `${process.env.BASE_API_URL}/reactionsfavoritelist/?user=${this.authUser.user.id}&reacted_on_id=${this.post.postId}&circle_id=${this.currentCircle.id}&reacted_on_type=1&role=${this.authUser.user.role}&page_num=1&items=1`,
            //         { headers }
            //       )
            //       .then(res => {
            //         this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
            //         this.post.hugs_reacted_users = res.data.data.data[0].favorite[0].hugs_reacted_users
            //         this.post.happy_reacted_users = res.data.data.data[0].favorite[0].happy_reacted_users
            //         this.post.sad_reacted_users = res.data.data.data[0].favorite[0].sad_reacted_users
            //         this.post.likes_reacted_users = res.data.data.data[0].favorite[0].likes_reacted_users
            //         this.post.angry_reacted_users = res.data.data.data[0].favorite[0].angry_reacted_users
            //         this.post.my_reaction = res.data.data.data[0].favorite[0].my_reaction
            //         this.posting = false
            //       })
            //       .catch(err => {
            //         this.$notification.error({ message: "Error - R1", description: "Reacted users cannot be fetched profile part" })
            //         this.posting = false
            //       })
            //     break

            //   case "job":
            //     this.$http
            //       .get(
            //         `${process.env.BASE_API_URL}/reactionsfavoritelist/?user=${this.authUser.user.id}&reacted_on_id=${this.post.postId}&circle_id=${this.currentCircle.id}&reacted_on_type=12&role=${this.authUser.user.role}&page_num=1&items=1`,
            //         { headers }
            //       )
            //       .then(res => {
            //         this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
            //         this.post.hugs_reacted_users = res.data.data.data[0].favorite[0].hugs_reacted_users
            //         this.post.happy_reacted_users = res.data.data.data[0].favorite[0].happy_reacted_users
            //         this.post.sad_reacted_users = res.data.data.data[0].favorite[0].sad_reacted_users
            //         this.post.likes_reacted_users = res.data.data.data[0].favorite[0].likes_reacted_users
            //         this.post.angry_reacted_users = res.data.data.data[0].favorite[0].angry_reacted_users
            //         this.post.my_reaction = res.data.data.data[0].favorite[0].my_reaction
            //         this.posting = false
            //       })
            //       .catch(err => {
            //         this.$notification.error({ message: "Error - R2", description: "Reacted users cannot be fetched profile part" })
            //         this.posting = false
            //       })
            //     break

            //   case "event":
            //     this.$http
            //       .get(
            //         `${process.env.BASE_API_URL}/reactionsfavoritelist/?user=${this.authUser.user.id}&reacted_on_id=${this.post.postId}&circle_id=${this.currentCircle.id}&reacted_on_type=13&role=${this.authUser.user.role}&page_num=1&items=1`,
            //         { headers }
            //       )
            //       .then(res => {
            //         this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
            //         this.post.hugs_reacted_users = res.data.data.data[0].favorite[0].hugs_reacted_users
            //         this.post.happy_reacted_users = res.data.data.data[0].favorite[0].happy_reacted_users
            //         this.post.sad_reacted_users = res.data.data.data[0].favorite[0].sad_reacted_users
            //         this.post.likes_reacted_users = res.data.data.data[0].favorite[0].likes_reacted_users
            //         this.post.angry_reacted_users = res.data.data.data[0].favorite[0].angry_reacted_users
            //         this.post.my_reaction = res.data.data.data[0].favorite[0].my_reaction
            //         this.posting = false
            //       })
            //       .catch(err => {
            //         this.$notification.error({ message: "Error - R3", description: "Reacted users cannot be fetched profile part" })
            //         this.posting = false
            //       })
            //     break

            //   case "press":
            //   case "pressRelease":
            //   case "pressrelease":
            //     this.$http
            //       .get(
            //         `${process.env.BASE_API_URL}/reactionsfavoritelist/?user=${this.authUser.user.id}&reacted_on_id=${this.post.postId}&reacted_on_type=14&circle_id=${this.currentCircle.id}&role=${this.authUser.user.role}&page_num=1&items=1`,
            //         { headers }
            //       )
            //       .then(res => {
            //         this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
            //         this.post.hugs_reacted_users = res.data.data.data[0].favorite[0].hugs_reacted_users
            //         this.post.happy_reacted_users = res.data.data.data[0].favorite[0].happy_reacted_users
            //         this.post.sad_reacted_users = res.data.data.data[0].favorite[0].sad_reacted_users
            //         this.post.likes_reacted_users = res.data.data.data[0].favorite[0].likes_reacted_users
            //         this.post.angry_reacted_users = res.data.data.data[0].favorite[0].angry_reacted_users
            //         this.post.my_reaction = res.data.data.data[0].favorite[0].my_reaction
            //         this.posting = false
            //       })
            //       .catch(err => {
            //         this.$notification.error({ message: "Error - R4", description: "Reacted users cannot be fetched profile part" })
            //         this.posting = false
            //       })
            //     break
            // }
          } else {
            console.log("FROM PROFILE SAVED - ELSE PART");
            this.$http
              .get(
                `${process.env.BASE_API_URL}/dovemedpost/?id=${this.post.postId}&circle_id=${this.currentCircle.id}&page_num=1&items=1`,
                { headers }
              )
              .then((res) => {
                this.post.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1;
                console.log("RESPONSE ->", res.data.data.data);
                switch (this.post.content_type) {
                  case "post":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].angry_reacted_users;
                    this.post.my_reaction = res.data.data.data[0].my_reaction;
                    break;
                  case "job":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].user_job.hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].user_job.happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].user_job.sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].user_job.likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].user_job.angry_reacted_users;
                    this.post.my_reaction =
                      res.data.data.data[0].user_job.my_reaction;
                    break;
                  case "event":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].user_event.hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].user_event.happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].user_event.sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].user_event.likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].user_event.angry_reacted_users;
                    this.post.my_reaction =
                      res.data.data.data[0].user_event.my_reaction;
                    break;
                  case "press":
                  case "pressRelease":
                  case "pressrelease":
                    this.post.hugs_reacted_users =
                      res.data.data.data[0].user_press.hugs_reacted_users;
                    this.post.happy_reacted_users =
                      res.data.data.data[0].user_press.happy_reacted_users;
                    this.post.sad_reacted_users =
                      res.data.data.data[0].user_press.sad_reacted_users;
                    this.post.likes_reacted_users =
                      res.data.data.data[0].user_press.likes_reacted_users;
                    this.post.angry_reacted_users =
                      res.data.data.data[0].user_press.angry_reacted_users;
                    this.post.my_reaction =
                      res.data.data.data[0].user_press.my_reaction;
                    break;
                }
                this.posting = false;
              })
              .catch((err) => {
                this.$notification.error({
                  message: "Error - R2",
                  description: "Reacted users cannot be fetched",
                });
                this.posting = false;
              });
          }
        })

        .catch((err) => {
          this.posting = false;
        });
    },

    formatPostTime(value) {
      const d = new Date(value);
      const now = new Date();
      const seconds = Math.round(
        Math.abs((now.getTime() - d.getTime()) / 1000)
      );
      const minutes = Math.round(Math.abs(seconds / 60));
      const hours = Math.round(Math.abs(minutes / 60));
      const days = Math.round(Math.abs(hours / 24));
      const months = Math.round(Math.abs(days / 30.416));
      const years = Math.round(Math.abs(days / 365));
      if (Number.isNaN(seconds)) {
        return "";
      } else if (seconds <= 45) {
        return "a few seconds ago";
      } else if (seconds <= 90) {
        return "a minute ago";
      } else if (minutes <= 45) {
        return minutes + " minutes ago";
      } else if (minutes <= 90) {
        return "an hour ago";
      } else if (hours <= 22) {
        return hours + " hours ago";
      } else if (hours <= 36) {
        return "a day ago";
      } else if (days <= 25) {
        return days + " days ago";
      } else if (days <= 45) {
        return "a month ago";
      } else if (days <= 345) {
        return months + " months ago";
      } else if (days <= 545) {
        return "a year ago";
      } else {
        // (days > 545)
        return years + " years ago";
      }
    },
    viewProfile() {
      if (this.post.user[0].role === "admin") {
        return;
      }
      // this.loadingScreen = true
      const user = this.post.user[0];
      if (
        user.id === this.authUser.user.id &&
        user.role === this.authUser.user.role
      ) {
        this.routeToAuthProfile(this.authUser.user.role);
      } else {
        this.$store.commit("User/setViewUser", {
          data: { ...this.viewUser, isDirectory: false },
        });
        switch (user.role) {
          case "doctor":
          case "physician":
            this.$router.push({
              name: "ViewDoctorUpdates",
              params: { id: user.id },
            });
            break;
          case "hcp":
          case "ohcp":
          case "ahcp":
          case "other":
            this.$router.push({
              name: "ViewHcpUpdates",
              params: { id: user.id },
            });
            break;
          case "clinic_administrator":
            this.$router.push({
              name: "ViewClinicAbout",
              params: { id: user.id },
            });
            break;
          case "hospital_administrator":
            this.$router.push({
              name: "ViewHos_adminAbout",
              params: { id: user.id },
            });
            break;
          case "nfp":
            this.$router.push({
              name: "ViewNfpAbout",
              params: { id: user.id },
            });
            break;
          case "patient":
            this.$router.push({
              name: "ViewPatientUpdates",
              params: { id: user.id },
            });
            break;
          case "caregiver":
            this.$router.push({
              name: "ViewPatientUpdates",
              params: { id: user.id, role: "caregiver" },
            });
            break;
          case "advocate":
            this.$router.push({
              name: "ViewAdvocateAbout",
              params: { id: user.id },
            });
            break;
          case "hospital":
            this.$router.push({
              name: "HospViewAbout",
              params: { id: user.id },
            });
            break;
          case "clinic":
            this.$router.push({
              name: "ClinicViewAbout",
              params: { id: user.id },
            });
            break;
          case "nfp_administrator":
            this.$router.push({
              name: "ViewNfpAdminAbout",
              params: { id: user.id },
            });
            break;
          default:
            break;
        }
      }
    },
    savePost() {
      const R_ON_TYPE = {
        POST: 1,
        JOB: 12,
        EVENT: 13,
        PRESS: 14,
        PRESSRELEASE: 14,
      };
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      };
      if (!this.postSaved) {
        PostRepository.saveReaction(this.currentCircle.id, {
          reacted_on_type: R_ON_TYPE[this.post.content_type.toUpperCase()],
          reacted_on_id: this.post.id,
          user: this.authUser.user.id,
          user_role: this.authUser.user.role || "",
          reaction_type: 4,
        })
          .then((res) => {
            this.postSaved = true;
            this.post.my_reaction.push(res.data.data);
            this.$notification.success({
              message: "Saved",
              description: `This ${
                this.post.content_type === "press"
                  ? "press release"
                  : this.post.content_type
              } is saved`,
            });
          })
          .catch((err) => {
            this.$notification.error({
              message: "Error",
              description: `This ${
                this.post.content_type === "press"
                  ? "press release"
                  : this.post.content_type
              } cannot be saved`,
            });
          });
      } else {
        const saveId = this.post.my_reaction.filter(
          (r) => r.reaction_type === 4
        )[0].id;
        this.$http
          .delete(`${process.env.BASE_API_URL}/reactions/?ids=${saveId}`, {
            headers,
          })
          .then((res) => {
            this.postSaved = false;
            this.$notification.success({
              message: "Unsaved",
              description: `This ${this.post.content_type} is unsaved`,
            });
            if (this.fromProfileSaved) {
              this.fetchPosts();
            }
          })
          .catch((err) => {
            this.$notification.error({
              message: "Error",
              description: `This ${this.post.content_type} cannot be unsaved`,
            });
          });
      }
    },
    muteUser() {
      UserRepository.muteUser({
        user_circle: this.currentCircle.id,
        user_id: this.post.user[0].id,
        role: this.post.user[0].role,
      })
        .then((res) => {
          this.$notification.success({
            message: "Muted",
            description: "This user has been muted successfully",
          });
          if (!this.fromShare) {
            this.fetchPosts();
          } else {
            this.$router.push({ name: "ActivityHome" });
          }
        })
        .catch((e) => {
          this.$notification.error({
            message: "Error",
            description: "Cannot mute user",
          });
        });
    },
  },
};
</script>

<style lang="scss">
hr {
  margin: 1rem -15px;
}

.hw20 {
  height: 20px;
  width: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: -3px;
}

.showReactions {
  position: relative;
}

.emojiReactions {
  visibility: hidden;
  opacity: 0;
  z-index: -1;
  transform: translateY(30px);
  transition: all 1s;
  position: absolute;
  top: -60px;
  left: -20px;
}

.showReactions:hover .emojiReactions,
.emojiReactions:hover {
  visibility: visible;
  opacity: 1;
  z-index: 1;
  transform: translateY(0);
}

.dot-menu-cont {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  // height: 50%;
}

.fa-camera {
  width: 35px;
  height: 35px;
  position: relative;
  vertical-align: text-top;
  cursor: pointer;
}

.camera-icon-inp {
  opacity: 0;
  position: absolute;
  right: 55px;
  top: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 5;

  &::-webkit-file-upload-button {
    opacity: 0;
    position: absolute;
    right: 55px;
    top: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 5;
  }
}

.sub-text {
  font-size: 14px !important;
  // font-size: 16px !important;
}

.image-uploading {
  height: auto;
  margin: 20px;
  display: flex;
  flex-wrap: wrap;
}

// .post-image {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// }
.post__tags {
  margin-bottom: 20px;
  // margin: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  .tags {
    padding: 3px 16px;
    display: inline-block;
    font-weight: 700;
    font-size: 12px;
    // margin-right: 5px;
    line-height: 1.5;
    // margin: 5px;
  }

  .popover-button {
    // margin: 5px;
    line-height: 1em;

    button {
      background: none;
      border: none;
    }
  }
}

.promoted-post-head {
  padding: 8px 16px;
  display: flex;
  border-radius: 8px 8px 0px 0px;
  align-items: center;
  font-size: 10px;
  // line-height: 12px;
  font-weight: 700;

  div:first-child {
    transform: scale(0.1);
    width: 40px;
  }

  div:last-child {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
}

.delete-post-dropdown {
  position: absolute;
  right: 0px;
}

.dropdown-text {
  font-weight: 500;
  font-size: 16px;
  padding: 10px 20px;
  color: #333333;
  line-height: 24px;
}

.shadow-card {
  .posted-reactions-text {
    // width: 120px !important;
    text-align: left !important;
    padding-right: 0 !important;
  }
}

.card-item {
  font-weight: 400 !important;
}

.spinnerContainer-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
  // z-index: 999;
}

.u-options div {
  padding-left: 6px !important;
}

.card-item:hover,
.dropdown-text:hover {
  background: rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 600px) {
  .posted-reactions-text {
    display: none;
  }

  div.like-text,
  .reply-btns {
    display: block;
  }

  .name-with-feeling {
    flex-direction: column;
    align-items: flex-start !important;

    .sub-text {
      margin-left: 0 !important;
      margin-bottom: 8px !important;
    }
  }

  .m-ml-0 {
    transform: scale(0.8);
    margin-left: 0 !important;
  }

  .commentText {
    font-size: 12px !important;
  }
}

p.cp.text-capitalize {
  word-break: break-word;
}

.like-comment-gap {
  gap: 10%;

  @media screen and (max-width: 600px) {
    justify-content: space-between;
  }
}

.cam-inp-right {
  right: 130px !important;

  @media screen and (max-width: 600px) {
    right: 85px !important;
  }
}

.two-image-grid {
  grid-template-areas: "first" "second";
}

.more-image-grid {
  grid-template-areas: "first first" "first first" "second third";
}

.multiImgs {
  display: grid;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    // object-fit: cover;
    // background: white;
    max-height: 360px;
  }

  .position-relative {
    display: none;
  }

  .first {
    grid-area: first;
    max-height: 360px;
  }

  .second {
    grid-area: second;
  }

  .third {
    grid-area: third;
  }

  .first,
  .second,
  .third {
    display: block !important;
  }

  .more {
    background: #0f1734 !important;
    opacity: 0.6;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    cursor: pointer;
  }

  .moreText {
    cursor: pointer;
    font-weight: 700;
    position: absolute;
    font-size: 24px;
    line-height: 24px;
    color: #ffffff !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Post.vue